<div class="hide-desktop">
    <div class="text-center">
        <ng-template *ngTemplateOutlet="actionBtns; context:{isMobile:false}"></ng-template>
    </div>
    <div class="d-flex flex-row">  
        <div class="d-flex border shadow-sm m-2 flex-fill">
            <div class="d-flex flex-row mt-2 pb-1 w-100">
                <button mat-icon-button class="me-2 text-danger">
                    <mat-icon class="material-symbols-outlined" [ngClass]="{'color-danger':addWizObj.isActionPending, 'color-success':!addWizObj.isActionPending}">{{addWizObj.isActionPending?"error":"check_circle"}}</mat-icon>
                </button>
                <div class="me-auto">
                    <b (click)="dialogService.viewCertificates(addWizObj.applicantId)" class="text-clickable m-2">{{personalInfo?.firstName}} {{personalInfo?.lastName}}</b>
                    <br />
                    <span (click)="dialogService.viewCertificates(addWizObj.applicantId)"class="text-clickable m-2">{{addWizObj.applicantId}}</span>
                </div>
                <button mat-icon-button class="me-2 ms-auto" (click)="dialogService.viewAppWizardHeader({addWizObj,personalInfo, isApp:true})"><mat-icon>more_vert</mat-icon></button>
            </div>
        </div>
        <div class="d-flex border shadow-sm m-2" *ngIf="userService.isEduAgent()">
            <app-app-notes></app-app-notes>
        </div>
    </div>
    <div class="title mx-3 my-1 shadow-sm p-3 pb-1">
        <h1 class="h1">APPLICATION WIZARD</h1>
    </div>
    <div class="d-flex flex-row mx-3 my-1 shadow-sm p-3">
        <button mat-icon-button class="me-2 bg-active color-white" *ngIf="!isAppWizCompleteMobileView()">{{isAcceptanceArtifactSelected()? "3" : "2"}}</button>
        <button mat-icon-button *ngIf="isAppWizCompleteMobileView()" class="bg-complete color-complete me-2"><mat-icon>check</mat-icon></button>

        <div>
            <h2 class="h2 fs-4 color-active">{{isAcceptanceArtifactSelected()? "Review and Sign" : "Provide Documentation"}}</h2>
            <span *ngIf="!isAppWizCompleteMobileView()">In Progress</span>
            <span *ngIf="isAppWizCompleteMobileView()" class="color-complete">Complete</span>
        </div>
        <button mat-icon-button class="me-2 ms-auto" (click)="dialogService.viewCertWizController(addWizObj, true)"><mat-icon>keyboard_arrow_down</mat-icon></button>
    </div>
</div>


<div class="container px-0 max-w-100">
    <div class="row mx-0">
        <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3 py-4 left-bar-desktop hide-mobile px-0" (click)="setIsMobile(false)">
            <div class="mx-3 mb-2">
                <button type="button" class="btn shadow w-100" (click)="certWizService.certWizardRedirect()">
                    <div class="d-flex justify-content-between">
                        Start new Application 
                        <mat-icon>add</mat-icon>
                    </div>
                </button>
            </div>
            <app-cert-wiz-controller [isApp]="true" [addWizObj]="addWizObj"></app-cert-wiz-controller>
        </div>
        <div class="col-sm-12 col-md-9 col-lg-9 col-xl-9 py-4" (click)="setIsMobile(false)">
            <div class="primary">
                <div class="text-center hide-mobile mb-3">
                    <ng-template *ngTemplateOutlet="actionBtns; context:{isMobile:false}"></ng-template>
                </div>
                <div class="d-flex flex-row">  
                    <div class="hide-mobile flex-grow-1">
                        <mat-expansion-panel [expanded]="false">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="text-nowrap">
                                    <div class="d-flex">
                                        <span class="my-auto">
                                            <mat-icon class="material-symbols-outlined" [ngClass]="{'color-danger':addWizObj.isActionPending, 'color-success':!addWizObj.isActionPending}">
                                                    {{addWizObj.isActionPending?"error":"check_circle"}}
                                            </mat-icon>
                                        </span>
                                        <span class="my-auto"><mat-icon class="material-symbols-outlined">person</mat-icon></span>
                                        <b (click)="dialogService.viewCertificates(addWizObj.applicantId)" class="text-clickable m-2">{{personalInfo?.firstName}} {{personalInfo?.lastName}}</b>
                                        <span (click)="dialogService.viewCertificates(addWizObj.applicantId)" class="text-clickable m-2">{{addWizObj.applicantId}}</span>
                                        <b class="m-2">{{addWizObj.approachDisplay}}</b>
                                        <span class="m-2">{{addWizObj.appId}}</span>
                                    </div>
                                    <div class="determinate-spinner ms-3 d-flex flex-row" *ngIf="addWizObj.hasExpiry()">
                                        <mat-spinner style="width: 30px; height: 30px;" class="my-auto" mode="determinate" [value]="addWizObj.deadlineRemain*100/addWizObj.deadlineTotal">
                                        </mat-spinner>
                                        <div class="my-auto number" [matTooltip]="TOOLTIP.deadlineRemain(addWizObj.deadlineRemain)">{{addWizObj.deadlineRemain}}</div>
                                    </div>
                                    <span class="ms-auto"></span>                        
                                    <span class="rounded p-2 badge-bg-primary">{{addWizObj.status?.Display || 'Started'}}</span>                        
                                    <span class="rounded p-2 badge-bg-primary badge-waiting mx-2" *ngIf="addWizObj.waitingRole">Waiting {{addWizObj.waitingRole}}</span>                        
                        
                                    <button class="btn btn-link m-2" (click)="viewDocument()" *ngIf="getAppPDFDocId()">Application</button>
                                    <!-- <button class="btn m-2" (click)="deleteApp()" *ngIf="addWizObj.status?.Value=='started'"><span class="material-symbols-outlined pt-2">delete</span></button> -->
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="mt-2 body-text">
                                <div class="pt-2">
                                    Start: <span class="color-light">{{addWizObj.startedDate | date:'MM/dd/yyyy'}}</span>
                                    <ng-container *ngIf="addWizObj.hasDeadline()"> | Deadline: <span class="color-light">{{addWizObj.deadlineDate | date:'MM/dd/yyyy'}}</span></ng-container>
                                </div>
                                <div class="pt-2">
                                    Submitted Date:
                                    <span class="color-light">
                                        {{addWizObj.packageCompleteDate ? (addWizObj.packageCompleteDate | date:'MM/dd/yyyy') : 'Pending'}}
                                    </span> |
                                    Decision Date:
                                    <span class="color-light">
                                        {{addWizObj.decisionDate ? (addWizObj.decisionDate | date:'MM/dd/yyyy') : 'Pending'}}
                                    </span> |
                                    Fee: <span class="color-light">{{getAppTotalFee()}}</span>
                                </div>
                                <ng-container *ngIf="addWizObj.approach === 'PrincipalAct' && addWizObj.appExtensionsList?.[0]?.properties as pa">
                                    <div class="pt-2 d-flex flex-wrap align-items-center gap-2">
                                        <span class="rounded px-2 py-1"
                                            [style.background-color]="pa.hardToStaff ? '#e6f4ea' : '#fbf0db'"
                                            [style.color]="pa.hardToStaff ? '#1e7e34' : '#8a6d3b'">
                                            Hard to Staff = {{ pa.hardToStaff ? 'Yes' : 'No' }}
                                        </span>
                                        <span class="rounded px-2 py-1"
                                            [style.background-color]="pa.retireEndOfSchoolYear === 'Yes' ? '#e6f4ea' : '#fbf0db'"
                                            [style.color]="pa.retireEndOfSchoolYear === 'Yes' ? '#1e7e34' : '#8a6d3b'">
                                            Retirement at End of School Year = {{ pa.retireEndOfSchoolYear === 'Yes' ? 'Yes' : 'No' }}
                                        </span>
                                    </div>
                                    <div class="pt-2">
                                        Base Stipend: <span class="color-light">{{pa.baseStipendAmount | currency}}</span>
                                        | Hard-to-Staff Supplement: <span class="color-light">{{pa.supplementAmount | currency}}</span>
                                    </div>
                                </ng-container>
                            </div>
                        </mat-expansion-panel>
                    </div>
                    <div class="align-self-start border shadow hide-mobile mx-2" *ngIf="userService.isEduAgent()">
                        <app-app-notes></app-app-notes>
                    </div>
                </div>
                <ng-template *ngTemplateOutlet="AppWizard; context:{isMobile:false}"></ng-template>
            </div>
        </div>
    </div>
</div>

<ng-template #AppWizard let-isMobile="isMobile">
    <ng-container *ngFor="let artifact of addWizObj.artifacts; let index=index">
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.PERSONAL" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{label:'Personal Data:- Review your personal data. If correct, scroll down and click next to complete this section.', artifact}"></ng-template>
            <app-personal-data [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"
                [personalInfo]="personalInfo"></app-personal-data>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.CITIZENSHIP" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-proof-of-citizenship [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-proof-of-citizenship>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.MILITARY" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-military-declaration [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-military-declaration>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.CRIMINAL" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-professional-status-criminal-history [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-professional-status-criminal-history>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.EDUCATIONAL" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-education-record [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-education-record>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.EDUCATIONAL_SUBSTITUTE" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-education-record-substitute [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-education-record-substitute>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.EDUCATIONAL_TE" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-education-record-te [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-education-record-te>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.EDUCATIONAL_HS" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-education-record-hs [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-education-record-hs>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.EXPERIENCE" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-educational-experience [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-educational-experience>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.PRAXIS" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-praxxis-assessment-list [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-praxxis-assessment-list>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.formSchema" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-form-section-artifact [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-form-section-artifact>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.INTERNSHIP_PLACEMENT" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-internship-placement [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-internship-placement>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.CLASS_AA" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-class-info-aa [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-class-info-aa>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.CLASS_A_ALT" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-class-info-a-alternative [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-class-info-a-alternative>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.CLASS_A_TRD" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-class-info-a-traditional [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-class-info-a-traditional>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.CLASS_B" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-class-info-b [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-class-info-b>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.SCHOOL_PLACEMENT" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-school-placement [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-school-placement>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.SCHOOL_SYSTEM_SELECTION" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-school-system-selection [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-school-system-selection>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.TEAMS_CONTRACT_DETAILS" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-teams-contract-details [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-teams-contract-details>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.ACCEPTANCE" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-acceptance-signature [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-acceptance-signature>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.ACCEPTANCE_OLR" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-acceptance-signature [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-acceptance-signature>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.ACCEPTANCE_IHE" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-acceptance-signature [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-acceptance-signature>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.ACCEPTANCE_LEA" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-acceptance-signature [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-acceptance-signature>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.ACCEPTANCE_3rdParty" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-acceptance-signature [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-acceptance-signature>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.ACCEPTANCE_LEA_PA" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-acceptance-signature [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-acceptance-signature>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.ACCEPTANCE_LEA_VHD" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-acceptance-signature [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-acceptance-signature>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.ACCEPTANCE_LEA_TEAMS" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-acceptance-signature [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-acceptance-signature>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.ACCEPTANCE_LEA_OLR" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-acceptance-signature [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-acceptance-signature>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.MOREINFO" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-more-information-needed [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-more-information-needed>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.MENTOR" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-cert-person-lookup [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-cert-person-lookup>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.SUPERVISOR_SELECT" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-cert-person-lookup [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-cert-person-lookup>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.APPFEE" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-appfee [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-appfee>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.OLR_POWER_SCHOOL_ATTESTATION" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-power-school-attestation [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-power-school-attestation>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.PA_PRINCIPAL_ATTESTATION" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-power-school-attestation [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-power-school-attestation>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.PA_INTERIM_ATTESTATION" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-power-school-attestation [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-power-school-attestation>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.PA_TRANSCRIPT_ATTESTATION" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-power-school-attestation [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-power-school-attestation>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.PA_EARLY_LITERACY_ATTESTATION" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-power-school-attestation [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-power-school-attestation>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.PA_EARLY_LITERACY_NA_ATTESTATION" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-power-school-attestation [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-power-school-attestation>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.PA_EVALUATION_ATTESTATION" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-power-school-attestation [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-power-school-attestation>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.OLR_RCR_COURSEWORK" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-rcr-coursework [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-rcr-coursework>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.OLR_VERIFY_PD" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-verify-prof-development [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-verify-prof-development>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.OLR_CE_OPTION_CAREER" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-olr-ce-option [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-olr-ce-option>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.OLR_CE_OPTION_LEAD" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-olr-ce-option [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-olr-ce-option>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.OLR_CE_OPTION_PROF" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-olr-ce-option [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-olr-ce-option>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.key == ARTIFACT.NON_RENEWAL_REASON" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-non-renewal [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-non-renewal>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.type == ARTIFACT_TYPE.TranscriptArtifact" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-transcript [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-transcript>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.type == ARTIFACT_TYPE.FormDownloadArtifact" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-form-download [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-form-download>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.type == ARTIFACT_TYPE.FileUploadArtifact" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-file-upload-form [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-file-upload-form>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.type == ARTIFACT_TYPE.BgrArtifact" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-bgr-form [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-bgr-form>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.type == ARTIFACT_TYPE.AcknowledgementArtifact" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-acknowledge [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-acknowledge>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>
        <div class="m-3" *ngIf="artifact.type == ARTIFACT_TYPE.DocumentReviewArtifact" [hidden]="_ui.expandedArtifactId.value !== artifact.artifactId">
            <ng-template *ngTemplateOutlet="matStepLabel; context:{artifact}"></ng-template>
            <app-document-review [artifact]="artifact" [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))"
                [isMobile]="isMobile" [submit$]="submit$" [reset$]="reset$"></app-document-review>
            <app-artifact-action [artifact]="artifact"
                [stepControl]="$any(stepperFormGroup.get(artifact.artifactId))" [isMobile]="isMobile"
                [submit$]="submit$" [reset$]="reset$"></app-artifact-action>
        </div>

        <div *ngIf="false">
            <!-- TODO by add new artifactType -->
            <p> {{artifact.text}}</p>
            <ng-container>
                <app-btn-action *ngFor="let action of artifact.actions" [action]="action" (onClick)="_ui.selectedTab.appWizard=1"></app-btn-action>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<ng-template #matStepLabel let-artifact="artifact">
    <div class="d-flex border-bottom text-wrap">
            <h2 class="h2 mt-1 mb-0">{{artifact.name || artifact.type}}</h2>
            <span class="responsibility-box my-0 mx-3">
                {{ROLE_DISPLAY_NAMES[artifact.role] || artifact.role + ' Responsibility'}}
            </span>
    </div>
    <div class="text-end mt-2">
        <div *ngIf="isReadonly(artifact)">
            <mat-icon title="Read Only!">edit_off</mat-icon>
            <span class="align-top"> you don't have editing permission</span>
        </div>
    </div>
</ng-template>

<ng-template #actionBtns>
    <div class="d-flex justify-content-end p-2 hide-desktop">
        <div class="mt-1 me-3">
            <button type="button" class="btn shadow w-100" (click)="certWizService.certWizardRedirect()">
                <div class="d-flex justify-content-between">
                    Start new Application
                    <mat-icon>add</mat-icon>
                </div>
            </button>
        </div>
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu" class="border rounded-50">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="dialogService.requestApplicantResubmit(addWizObj.appId)"
                *ngIf="displayResubmitApplication()">
                <mat-icon>autorenew</mat-icon>
                <span>Request Applicant Resubmit</span>
            </button>
            <button mat-menu-item (click)="dialogService.denyApplication(addWizObj.appId)" *ngIf="displayDenyApplication()">
                <mat-icon>close</mat-icon>
                <span>Deny Application</span>
            </button>
            <button mat-menu-item (click)="deleteApp()" *ngIf="addWizObj.status?.Value=='started'">
                <mat-icon>delete</mat-icon>
                <span>Delete Application</span>
            </button>
        </mat-menu>
    </div>


    <div class="hide-mobile">
        <div class="btn-group">
            <button type="button" class="btn color-button-secondary d-flex" (click)="dialogService.requestApplicantResubmit(addWizObj.appId)" *ngIf="displayResubmitApplication()"><mat-icon title="Request Applicant Resubmit">autorenew</mat-icon>Request Applicant Resubmit</button>
            <button type="button" class="btn color-button-secondary d-flex" (click)="dialogService.denyApplication(addWizObj.appId)" *ngIf="displayDenyApplication()"><mat-icon title="Deny Application">close</mat-icon>Deny Application</button>
            <button type="button" class="btn color-button-secondary d-flex" (click)="deleteApp()" *ngIf="addWizObj.status?.Value=='started'"><mat-icon title="Delete Application">delete</mat-icon>Delete Application</button>
        </div>
    </div>
</ng-template>
